import React, { useContext } from "react";
import { ActionDropdown } from "../ActionDropdown/ActionDropdown";
import { keyBillStatus, roles } from "../../../utils/constants";
import { ActionRoleSpecific, userHasLevel } from "../../../engine/AuthRoute";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { notification } from "antd";
import { RiDeleteBinLine, RiMailSendLine } from "react-icons/ri";
import { modalConfirmDeleteBill } from "../Modals/modals";
import { UserContext } from "../../../engine/context/User.context";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { FaRegFilePdf } from "react-icons/fa";
import useDocumentCreator from "../../../engine/hooks/useDocumentCreator";
import { http } from "../../../engine/api/http";
import { DeleteRowOutlined } from "@ant-design/icons";
import routes from "../../../engine/routes";
import { useTranslation } from "react-i18next";
import { getBill } from "../../../pages/Billing/Slices/Bill.slice";

export const BillAction = ({}) => {
  const { bill, loading } = useSelector(state => state.bill);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useContext(UserContext);
  const context = useContext(ModalContext);
  const { id } = useParams();
  const [get, createAndGet, isLoading, setUrl, doc] = useDocumentCreator();

  const { t, i18n } = useTranslation();

  const getPdf = () => {
    createAndGet(
      { bills: [id], language: i18n.language },
      `bills/${id}/pdf`,
      true,
      true,
      async () => {
        await dispatch(getBill(id));
      },
    );
  };

  const deleteBill = async () => {
    const showModalDelete = await new Promise((resolve, reject) => {
      modalConfirmDeleteBill({
        onOk: async () => {
          resolve(true);
        },
        onCancel: () => {
          reject(new Error("Update canceled."));
        },
      });
    });

    if (showModalDelete) {
      const res = await http.delete(`/bills/${id}`);
      notification.success({
        message: t("BillAction.deletionConfirmed"),
      });

      navigate(routes.billing().list.path, { replace: true });
    }
  };

  const canSendEmail = () => {
    return (
      [keyBillStatus.preparation, keyBillStatus.paid].includes(bill.status) ===
      false
    );
  };

  const sendEmailBill = async () => {
    try {
      if (canSendEmail()) {
        const action = await http.post(`/bills/${id}/send`);
        notification.success({ message: t("BillAction.emailSentSuccess") });
        await dispatch(getBill(id));
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <ActionDropdown>
      {userHasLevel({
        only: {
          [roles.admin]: "crud",
          [roles.permanance]: "crud",
        },
      }) ? (
        <>
          <span style={{ marginLeft: 5, marginRight: 10 }}>
            <RiMailSendLine color={"black"} size={18} />
          </span>
          <a
            onClick={sendEmailBill}
            disabled={!canSendEmail()}
            style={{
              opacity: !canSendEmail() ? 0.8 : 1,
            }}
          >
            {t("BillAction.sendByEmail")}
          </a>
        </>
      ) : null}
      <ActionRoleSpecific
        only={[roles.admin, roles.permanance, roles.institution]}
      >
        <span style={{ marginLeft: 5, marginRight: 10 }}>
          <FaRegFilePdf color={"black"} size={18} />
        </span>
        <a onClick={getPdf}>{t("BillAction.downloadBill")}</a>
      </ActionRoleSpecific>

      {userHasLevel({
        only: {
          [roles.admin]: "crud",
        },
      }) ? (
        <>
          <span style={{ marginLeft: 5, marginRight: 10 }}>
            <RiDeleteBinLine size={18} color={"red"} />
          </span>
          <a onClick={deleteBill}>{t("BillAction.deleteBill")}</a>
        </>
      ) : null}
    </ActionDropdown>
  );
};
